let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gsVNL")).then(() => parcelRequire('9tVif'));